import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { OwnerService } from "../../../services/billing-letter/owner.service";
import { OptionsBilling } from "../../enums/billing-letter/OptionsBilling";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { CompaniesService } from "../../../services/companies.service";
import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import { ConsultantService } from "../../../services/consultant.service";
import { ConsultantSearch } from "../../../models/ConsultantSearch.model";
import { UserService } from "../../../services/user.service";
import { ExcellenceCentersService } from "../../../services/excellenceCenters.service";
import { IndustriesService } from "../../../services/industries.service";

@Injectable()
export class BillingFiltersFactory extends FiltersFactory {
    constructor(
        private localStorage: LocalStorage,
        private ownerService: OwnerService,
        private commonHelper: CommonHelper,
        private optionsBilling: OptionsBilling,
        private companiesService: CompaniesService,
        private dropdownItemFactory: DropdownItemFactory,
        private dropdownSettingFactory: DropdownSettingsFactory,
        private consultantService: ConsultantService,
        private userService: UserService,
        private excellenceCentersService: ExcellenceCentersService,
        private industryService: IndustriesService
    ) { super() }

    async build(filters, localStorageFilterKey = 'billing-filters') {

        filters.companies.list = this.dropdownItemFactory.build({ source: await this.companiesService.listAllWithBillings(), 'type':"billing" });;
        filters.companies.list = filters.companies.list.map( item => {
            return {id : item.id, itemName:item.itemName, active:this.commonHelper.transcriptActive(item.active)};
        })

        filters.groups.list = this.dropdownItemFactory.build({ source: await this.companiesService.listAllGroupsWithBillings() });
        filters.owners.list = this.dropdownItemFactory.build({ source: await this.ownerService.getAll() });

        if(filters.consultant){
            let consultantSearch = new ConsultantSearch();
            consultantSearch.onlyActives = false;
            consultantSearch.limit = 9999999;
            filters.consultant.list = this.dropdownItemFactory.build({source: await this.consultantService.searchConsultants(consultantSearch)});
            filters.consultant.options = this.dropdownSettingFactory.build({text:"Consultores"});
        }

        if(filters.responsible){
            filters.responsible.list = this.dropdownItemFactory.build({source:await this.userService.getAllUsersAsResponsibles()});
            filters.responsible.options = this.dropdownSettingFactory.build({text:"Gestores"});
        }

        filters.status.list = this.optionsBilling.status;

        if(filters.statusAllParcels){
            filters.statusAllParcels.list = this.optionsBilling.statusAllParcels;
            filters.statusAllParcels.options = this.dropdownSettingFactory.build({ text: 'Status', singleSelection:true});
        }

        if (filters.year){
            let years: any = this.commonHelper.listLastYears();

            years = years.map(year => {
                return { _id: String(year), name: String(year) }
            });

            filters.year.list = this.dropdownItemFactory.build({source: years});
            filters.year.options = this.dropdownSettingFactory.build({text: 'Ano'});
            filters.year.options.enableCheckAll = true;
        }

        if (filters.month){
            filters.month.list = this.dropdownItemFactory.build({source:this.commonHelper.multiSelectMonths()});
            filters.month.options = this.dropdownSettingFactory.build({text:'Mês'});
            filters.month.options.enableCheckAll = true;
        }

        const centers = await this.excellenceCentersService.getAll();
        const industries = await this.industryService.getAll();
        if(filters.excellenceCenters)
            filters.excellenceCenters.list = this.dropdownItemFactory.build({ source: centers.filter(c => c.type == 1) });

        if(filters.supportCenters)
            filters.supportCenters.list = this.dropdownItemFactory.build({ source: centers.filter(c => c.type == 2) });

        if(filters.industries)
            filters.industries.list = this.dropdownItemFactory.build({ source: industries });

        filters.owners.options = this.dropdownSettingFactory.build({ text: 'Requisitantes' });
        filters.companies.options = this.commonHelper.getDropDownSettings(false, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true,'active','');
        filters.groups.options = this.dropdownSettingFactory.build({ text: 'Grupo de empresa' });
        filters.status.options = this.dropdownSettingFactory.build({ text: 'Status' });
        filters.excellenceCenters.options = this.dropdownSettingFactory.build({ text: 'Centro de Excelência' });
        filters.supportCenters.options = this.dropdownSettingFactory.build({ text: 'Área de Suporte' });
        filters.industries.options = this.dropdownSettingFactory.build({ text: 'Setores' });

        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/billing-letters/filters.factory.ts